import React from 'react';
import {
    Table, TableBody, TableCell, TableContainer, TableRow, Paper, Typography, Chip, Box, Divider, useTheme
} from '@mui/material';

const MetadataComponent = ({ metaData, title }) => {
    const theme = useTheme();
    // Filter out keys with empty values and create rows with key-value pairs
    const filteredData = Object.entries(metaData)
        .filter(([key, value]) => value !== undefined && value !== null && value !== '');

    // Render Chips for tags and keywords
    const renderChips = (values) => {
        return values.split(',').map((item, index) => (
            <Chip
                key={index}
                label={item.trim()}
                // variant="outlined"
                sx={{
                    margin: '2px',
                    fontSize: '0.875rem',
                    fontWeight: '500',
                    color: 'success.dark',
                    backgroundColor: 'success.light',
                    borderRadius: '8px',
                }}
            />
        ));
    };

    // Enhanced styling for category values
    const renderCategoryValue = (value) => (
        <Box
            sx={{
                display: 'inline-block',
                padding: '6px 10px',
                backgroundColor: 'primary.light',
                color: 'primary.main',
                fontWeight: 'bold',
                borderRadius: '6px',
                fontSize: '0.875rem',
            }}
        >
            {value}
        </Box>
    );

    return (
        <TableContainer component={Paper}
            sx={{
                width: "100%",
                border: 1,
                borderColor: "divider",
            }}
        >
            {title && (
                <Box
                    sx={{
                        backgroundColor: 'primary.light',    // Light blue background
                        paddingY: '14px',
                        paddingX: '20px',
                        fontWeight: 'bold',
                        fontSize: '1.4rem',
                        color: 'primary.main',              // Slightly darker blue text
                        fontFamily: '"Roboto", "Noto Sans Devanagari", sans-serif',
                        textTransform: 'capitalize',
                        borderRadius: "8px 8px 0 0",
                    }}
                >
                    <Typography align="center" variant="h6">
                        {title}
                    </Typography>
                    <Divider sx={{ marginTop: '8px', backgroundColor: 'primary.dark', height: '1px' }} />
                </Box>
            )}
            <Table size="small">
                <TableBody>
                    {filteredData.map(([key, value], index) => (
                        <TableRow key={index}>
                            <TableCell
                                sx={{
                                    fontWeight: 'bold',
                                    width: "150px",
                                    color: 'primary.dark',
                                    fontSize: '0.95rem',
                                    padding: '8px 16px',
                                }}
                            >
                                {key.charAt(0).toUpperCase() + key.slice(1)}
                            </TableCell>
                            <TableCell
                                sx={{
                                    padding: '8px 16px',
                                    color: 'text.primary',
                                    fontSize: '0.9rem',
                                    whiteSpace: 'pre-line',
                                    borderRadius: '4px',
                                }}
                            >
                                {key === 'tags' || key === 'keywords' ? (
                                    renderChips(value)
                                ) : (
                                    key === 'category' ? renderCategoryValue(value) : value
                                )}
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default MetadataComponent;
